import React, { Fragment, useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { MailIcon, KeyIcon } from "components/icons";
import { useGetOtp } from 'hooks/auth/Auth';
import { useVerifyOtp } from 'hooks/auth/Auth';

const OTP_LENGTH = 6;
const OTP_PATTERN = /^[0-9]{6}$/;

const stripSpaces = (value) => (value ?? "").replace(/\s/g, "");
const digitsOnly = (value) => (value ?? "").replace(/\D/g, "");

const VALIDATE_ON_BLUR = ["onBlur"];

const ForgotPassword = () => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const [otpSent, setOtpSent] = useState(false);

  const { mutate: verifyotp, isLoading: Loading } = useVerifyOtp();
  const { mutate: getotp, isLoading: otpLoading } = useGetOtp();

  const validateMessages = {
    types: {
      email: 'Enter a valid email address!',
    }
  }

  const onEmailChange = () => {
    if (otpSent) {
      setOtpSent(false);
      form.setFieldsValue({ verificationCode: undefined });
    }
  }

  const onFinish = (values) => {
    if (!otpSent) {
      getotp(values, {
        onSuccess: (item) => {
          if (item?.statusCode === 200) {
            message.success(item?.message);
            setOtpSent(true);
          }
          else {
            message.error(item?.message)
          }
        },
        onError: (error) => {
          console.log(error)
        }
      });
    } else {
      verifyotp(values, {
        onSuccess: (item) => {
          if (item?.statusCode === 200) {
            navigate(`/setPassword?email=${encodeURIComponent(values?.email)}`);
          }
          else {
            message.error(item?.message)
          }
        },
        onError: (error) => {
          console.log(error)
        }
      });
    }
  }

  return (
    <Fragment>
      <h2>Forgot Password?</h2>
      <p>{!otpSent
        ? "Enter your email and we'll send you a verification code"
        : "Enter the verification code we sent to your email"}</p>

      <Form
        form={form}
        onFinish={onFinish}
        validateMessages={validateMessages}
        autoComplete="off"
        name="forgotPassword_info"
        layout="vertical">
        <Form.Item
          name="email"
          normalize={stripSpaces}
          validateTrigger={VALIDATE_ON_BLUR}
          rules={[{ required: true, message: "Enter your email address!" }, { type: "email" }]}>
          <Input
            prefix={<MailIcon />}
            placeholder="Email address"
            autoComplete="username"
            maxLength={254}
            onChange={onEmailChange} />
        </Form.Item>
        <Form.Item
          hidden={!otpSent}
          name="verificationCode"
          normalize={digitsOnly}
          validateTrigger={VALIDATE_ON_BLUR}
          rules={!otpSent ? [] : [
            { required: true, message: "Enter the verification code!" },
            { pattern: OTP_PATTERN, message: `The code is ${OTP_LENGTH} digits!` },
          ]}>
          <Input
            prefix={<KeyIcon />}
            placeholder="Verification code"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={OTP_LENGTH} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={Loading || otpLoading} block>{!otpSent ? "Send Otp" : "Verify Otp"} </Button>
        </Form.Item>
      </Form>

      <p className="login-card-foot">
        <Link to={"/login"}>Back to login</Link>
      </p>
    </Fragment >
  );
}

export default ForgotPassword;
